import { Modal, Row, Col, Button, Rate, Grid, Skeleton } from 'antd';
import styled from "styled-components";
import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";
import { GatewayProvider } from '@civic/solana-gateway-react';
import { clusterApiUrl, Keypair, PublicKey } from "@solana/web3.js";
import { TOKEN_PROGRAM_ID, Token, AccountLayout } from "@solana/spl-token";
import {
  CANDY_MACHINE_PROGRAM,
} from "./candy-machine";
import { CircularProgress } from '@material-ui/core';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { MintButton } from './MintButton';
import { useAnchorWallet, useWallet } from "@solana/wallet-adapter-react";
import { sendTransaction } from './connection';

import * as anchor from "@project-serum/anchor";
import { COLOR, FONT } from './constants';
import _ from 'lodash';
import * as Service from './core/Service'


const { useBreakpoint } = Grid

const WalletAmount = styled.div`
  color: black;
  width: 100%;
  padding: 5px 5px 5px 16px;
  min-width: 48px
  min-height: auto;
  border-radius: 22px;
  border: 1px solid #000;
  box-sizing: border-box;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-weight: 500;
  line-height: 1.75;
  text-transform: uppercase;
  margin: 0;
  display: inline-flex;
  outline: 0;
  position: relative;
  align-items: center;
  user-select: none;
  vertical-align: middle;
  justify-content: space-between;
  gap: 10px;
  font-family: Space Grotesk;
`;
const ConnectButton = styled(WalletMultiButton)`
  border-radius: 18px !important;
  padding: 6px 16px;
  background-color: #4E44CE;
  margin: 0 auto;
  width: auto;
  width: 100%;
  font-size: 20px;
  font-weight: 400;
  font-family: Space Grotesk;
`;

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;
  }
`

let intervalRef: any

export const AppModal = (props: any) => {
  const [loading, setLoading] = useState(true)
  const [mintAddress, setMintAddress] = useState('nft')
  const [image, setImage] = useState('')
  const isMobile = useBreakpoint().xs;
  const [clicked, setClicked] = useState(false);

  const wallet = useWallet();



  const getTokenAccounts = useCallback(async () => {
    setLoading(true)
    intervalRef = setInterval(async () => {
      const info = await props.connection.getAccountInfo(new PublicKey(props.userTokenAddress))
      console.log('info', info);
      if (!info) return;
      const data = Buffer.from(info.data);
      console.log('data', data);
      const accountInfo = AccountLayout.decode(data);
      console.log('accountInfo', accountInfo);
      const mintAddress = new PublicKey(accountInfo.mint).toString();
      console.log('mintAddress', mintAddress);

      if (_.isEmpty(wallet.publicKey)) return;
      if (!mintAddress) return;
      clearInterval(intervalRef)
      const resp = await Service.call('get', `/api/nft/metadata/${mintAddress}`)
      setMintAddress(mintAddress)
      setImage(resp.data)
      setLoading(false)

    }, 1000)

  }, [props.connection, props.userTokenAddress, wallet.publicKey])


  useEffect(() => {
    if (props.alertState.severity !== 'success') return;
    if (_.isEmpty(props?.connection) || _.isEmpty(wallet) || _.isEmpty(props?.userTokenAddress)) return;
    getTokenAccounts()
  }, [props?.connection, props?.userTokenAddress, wallet, props?.alertState?.severity, getTokenAccounts])


  const renderButton = () => {
    if (!wallet) {
      return null
    }

    if (!props?.candyMachine) return null;

    if (props.isWLOnly && props.whitelistTokenBalance <= 0 && props.alertState.severity !== 'success') {
      return <Row justify='center' align='top' style={{ border: '1px solid #D20000', borderRadius: 18, padding: '10px 8px', marginBottom: 32 }}>
        <Col span={2} style={{ textAlign: 'center' }}>
          <img src='/warning_icon.png' style={{ width: 24, marginRight: 10, height: '100%', objectFit: 'contain' }} alt="icon" /></Col>
        <Col span={22} style={{ ...FONT.h6 }}>
          Oh! This wallet is not on our whitelist or has reached its mint limit.
        </Col>
      </Row>
    }

    if (
      props?.candyMachine?.state.isActive &&
      props?.candyMachine?.state.gatekeeper &&
      wallet.publicKey &&
      wallet.signTransaction) {

      return <GatewayProvider
        wallet={{
          publicKey:
            wallet.publicKey ||
            new anchor.web3.PublicKey(CANDY_MACHINE_PROGRAM),
          //@ts-ignore
          signTransaction: wallet.signTransaction,
        }}
        // // Replace with following when added
        // gatekeeperNetwork={candyMachine.state.gatekeeper_network}
        gatekeeperNetwork={
          props?.candyMachine?.state?.gatekeeper?.gatekeeperNetwork
        } // This is the ignite (captcha) network
        /// Don't need this for mainnet
        clusterUrl={props?.rpcUrl}
        options={{ autoShowModal: false }}
        handleTransaction={async (transaction: anchor.web3.Transaction) => {
          props?.setIsMinting(true);
          try {
            await sendTransaction(
              props.connection,
              wallet,
              transaction,
              [],
              true,
              'confirmed',
            );
            props?.setAlertState({
              open: true,
              message: 'Please sign minting',
              severity: 'info',
            });
          } catch (e) {
            props?.setAlertState({
              open: true,
              message:
                'Solana dropped the transaction, please try again',
              severity: 'warning',
            });
            console.error(e);
            // setTimeout(() => window.location.reload(), 2000);
            props?.setIsMinting(false);
            throw e;
          }
          await props?.startMint();
        }}
        broadcastTransaction={false}
      >
        <MintButton
          downloadLoading={loading}
          download={download}
          setAlertState={props.setAlertState}
          setModalVisible={props.setModalVisible}
          setClicked={setClicked}
          clicked={clicked}
          candyMachine={props?.candyMachine}
          isMinting={props.isMinting}
          // setIsMinting={props.setIsMinting}
          isActive={props.isActive}
          isEnded={props.isEnded}
          isSoldOut={props.isSoldOut}
          onMint={props.startMint}
          success={props?.alertState?.severity === 'success' ?? false}
          setIsMinting={props?.setIsMinting}
        />
      </GatewayProvider>
    }

    if (
      props?.candyMachine?.state.isActive &&
      !props?.candyMachine?.state.gatekeeper &&
      wallet.publicKey &&
      wallet.signTransaction) {
      return (
        <MintButton
          downloadLoading={loading}
          download={download}
          setAlertState={props.setAlertState}
          setModalVisible={props.setModalVisible}
          setClicked={setClicked}
          clicked={clicked}
          candyMachine={props?.candyMachine}
          isMinting={props.isMinting}
          // setIsMinting={props.setIsMinting}
          isActive={props.isActive}
          isEnded={props.isEnded}
          isSoldOut={props.isSoldOut}
          onMint={props.startMint}
          success={props?.alertState?.severity === 'success' ?? false}
          setIsMinting={props?.setIsMinting}
        />
      )
    }

    return null
  }

  const renderErrorAlert = () => {
    if (!props?.alertState) return null

    if (props?.alertState?.severity === 'error') {
      return <Row justify='center' align='top' style={{ border: '1px solid #D20000', borderRadius: 18, padding: '10px 8px', marginBottom: 32 }}>
        <Col xs={3} sm={3} md={2} lg={2} style={{ textAlign: 'center', marginTop: 10 }}><img src='/warning_icon.png' style={{ width: 24, marginRight: 10, height: '100%', objectFit: 'contain' }} alt="icon" /></Col>
        <Col span={20} style={{ ...FONT.h6, color: COLOR.nagative }}>
          Mint failed. Either this wallet is not on our allowlist or an NFT has been already minted. Please ensure enough gas fee in the wallet and try again.
        </Col>
      </Row>
    }

    return null
  }

  function toDataURL() {
    return fetch(image)
      .then((response) => {
        return response.blob();
      })
      .then((blob) => {
        return URL.createObjectURL(blob);
      });
  }

  const download = async () => {
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = await toDataURL();
    a.download = `${mintAddress}.png`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  const renderContent = () => {

    // success content
    if (props.alertState.severity === 'success')
      return (
        <>
          <Row justify='center' gutter={[24, 24]} style={{ textAlign: 'center', marginBottom: 32 }}>
            <Col span={24} style={{ marginTop: 48, ...FONT.h3, color: COLOR.text }}>technine Shiba9 NFT</Col>
            <Col span={24}>
              <Rate style={{ fontSize: 42, color: COLOR.primary }} value={3} count={3} disabled />
            </Col>
            <Col span={24} style={{ ...FONT.h5, color: COLOR.captionText }}>Your mint is successful! </Col>
            <Col xs={24} sm={24} md={6} lg={6}>
              {loading ? <Skeleton.Button active style={{ width: 150, height: 150, borderRadius: 8 }} /> : <img src={image} alt="" style={{ width: '100%', borderRadius: 8 }} />}
            </Col>
          </Row>
        </>
      )

    // sold out content
    if (props.candyMachine?.state.isSoldOut || props.isSoldOut) {
      return (
        <Row justify='center' align='middle' style={{ textAlign: 'center', marginBottom: 30 }}>
          <Col span={24} style={{ marginTop: 48, marginBottom: 32, ...FONT.h3, color: COLOR.text }}>technine Shiba9 NFT</Col>
          <Col span={24} style={{ color: '#D20000', ...FONT.h6, marginBottom: 20 }}>
            <Row justify='center' align='middle' gutter={[24, 12]}>
              <Col><img alt="icon" src="/warning_icon.png" style={{ width: 40, height: '100%', objectFit: 'contain' }} /></Col>
              <Col> <span style={{ fontSize: isMobile ? 24 : 32 }}>Error</span></Col>
            </Row>
          </Col>
          <Col span={24} style={{ ...FONT.h5, color: COLOR.captionText }}>
            We're sorry, all the Shiba9 NFT has been minted. Stay tuned for our next campaign!
          </Col>
        </Row>
      )
    }

    if (
      props.isActive && (props.isMinting || clicked)
    ) {
      return (
        <>
          <Row justify='center' gutter={[24, 24]} style={{ textAlign: 'center', marginBottom: 32 }}>
            <Col span={24} style={{ marginTop: 48, ...FONT.h3, color: COLOR.text }}>technine Shiba9 NFT</Col>
          </Row>
          <Row justify='center' style={{ textAlign: 'center', marginBottom: 32 }}>
            <Col span={24}><CircularProgress style={{ color: COLOR.primary }} /></Col>
            <Col span={24} style={{ ...FONT.h4, color: COLOR.heading, marginBottom: 20 }}>Mint in Progress</Col>
            <Col span={22} style={{ ...FONT.h5, color: COLOR.captionText }}>

              Your Shiba9 is coming - it may take a few seconds to minutes. You can go to <a target="_blank" rel="noreferrer" href={`https://solscan.io/account/${wallet?.publicKey}`}><span style={{ color: COLOR.heading }}>solscan.io</span></a> to check the status.
            </Col>
          </Row>
        </>
      )
    }

    return (
      <>
        <Row justify='center' gutter={[24, 24]} style={{ textAlign: 'center', marginBottom: 32 }}>
          <Col span={24} style={{ marginTop: 48, ...FONT.h3, color: COLOR.text }}>technine Shiba9 NFT</Col>
          {/* <Col span={24} style={{ fontSize: 28, color: '#6464AF', fontFamily: 'Comfortaa', fontWeight: '400' }}>Rules: </Col> */}
          <Col span={24} style={{ ...FONT.h5, color: COLOR.captionText }}>Are you ready to mint your Shiba9?</Col>
        </Row>

        <Row justify='center' gutter={[0, 0]} style={{ marginBottom: 32 }}>

          <Col xs={24} md={16}>

            <div className='modal-wallet'><WalletAmount>
              <span style={{ width: '30%', textAlign: 'center', ...FONT.h5 }}> {(props.balance || 0).toLocaleString()} SOL </span>
              <ConnectButton /></WalletAmount></div>
          </Col>
        </Row>
        {renderErrorAlert()}
      </>
    )
  }


  return (
    <StyledModal
      centered
      destroyOnClose
      closable={!props?.isMinting}
      width={isMobile ? '95vw' : '50vw'}
      maskClosable={false}
      bodyStyle={{ width: '100%', padding: 32 }}
      footer={null}
      onCancel={() => {
        if (props?.alertState?.severity === 'success') {
          props.setAlertState({
            open: false,
            message: '',
            severity: undefined,
          })
        }
        props.setModalVisible(false);
      }}
      visible={props.modalVisible}
    >
      {renderContent()}
      <Row justify='center'>
        <Col xs={24} sm={24} md={16} lg={16} style={{ fontSize: 20, color: '#D20000', fontFamily: 'Comfortaa', fontWeight: 'bold', textAlign: 'center' }}>
          {renderButton()}
        </Col>
        <Col span={24} style={{ ...FONT.smallContent, color: COLOR.heading, textAlign: 'center', marginTop: 20 }}>Powered by NineBlocks</Col>
      </Row>
    </StyledModal>
  )
};


export default AppModal;